const emojiList = [
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_001.png',
    code: '[emoji_001]',
    label: '[微笑]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_002.png',
    code: '[emoji_002]',
    label: '[呲牙]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_003.png',
    code: '[emoji_003]',
    label: '[大笑]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_004.png',
    code: '[emoji_004]',
    label: '[坏笑]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_005.png',
    code: '[emoji_005]',
    label: '[笑哭]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_006.png',
    code: '[emoji_006]',
    label: '[捂脸]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_007.png',
    code: '[emoji_007]',
    label: '[送心]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_008.png',
    code: '[emoji_008]',
    label: '[可爱]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_009.png',
    code: '[emoji_009]',
    label: '[得意]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_010.png',
    code: '[emoji_010]',
    label: '[灵光一闪]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_011.png',
    code: '[emoji_011]',
    label: '[机智]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_012.png',
    code: '[emoji_012]',
    label: '[惊呆]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_013.png',
    code: '[emoji_013]',
    label: '[思考]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_014.png',
    code: '[emoji_014]',
    label: '[流泪]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_015.png',
    code: '[emoji_015]',
    label: '[尴尬]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_016.png',
    code: '[emoji_016]',
    label: '[抠鼻]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_017.png',
    code: '[emoji_017]',
    label: '[酷拽]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_018.png',
    code: '[emoji_018]',
    label: '[咆哮]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_019.png',
    code: '[emoji_019]',
    label: '[喷]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_020.png',
    code: '[emoji_020]',
    label: '[衰]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_021.png',
    code: '[emoji_021]',
    label: '[害羞]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_022.png',
    code: '[emoji_022]',
    label: '[捂嘴笑]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_023.png',
    code: '[emoji_023]',
    label: '[哇]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_024.png',
    code: '[emoji_024]',
    label: '[憨笑]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_025.png',
    code: '[emoji_025]',
    label: '[耶]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_026.png',
    code: '[emoji_026]',
    label: '[生无可恋]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_027.png',
    code: '[emoji_027]',
    label: '[尬笑]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_028.png',
    code: '[emoji_028]',
    label: '[飞吻]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_029.png',
    code: '[emoji_029]',
    label: '[爱慕]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_030.png',
    code: '[emoji_030]',
    label: '[鬼脸]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_031.png',
    code: '[emoji_031]',
    label: '[摸头]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_032.png',
    code: '[emoji_032]',
    label: '[鼓掌]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_033.png',
    code: '[emoji_033]',
    label: '[再见]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_034.png',
    code: '[emoji_034]',
    label: '[晕了]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_035.png',
    code: '[emoji_035]',
    label: '[鄙视]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_036.png',
    code: '[emoji_036]',
    label: '[大哭]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_037.png',
    code: '[emoji_037]',
    label: '[抓狂]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_038.png',
    code: '[emoji_038]',
    label: '[快哭了]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_039.png',
    code: '[emoji_039]',
    label: '[委屈]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_040.png',
    code: '[emoji_040]',
    label: '[擦汗]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_041.png',
    code: '[emoji_041]',
    label: '[酣睡]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_042.png',
    code: '[emoji_042]',
    label: '[犯困]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_043.png',
    code: '[emoji_043]',
    label: '[感冒]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_044.png',
    code: '[emoji_044]',
    label: '[元气满满]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_045.png',
    code: '[emoji_045]',
    label: '[真棒]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_046.png',
    code: '[emoji_046]',
    label: '[差劲]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_047.png',
    code: '[emoji_047]',
    label: '[握手]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_048.png',
    code: '[emoji_048]',
    label: '[OK]'
  },
  {
    iconPath: 'https://file.drstrong.cn/frontend/wechatApplet/v1.0.0/static/emoji/emoji_049.png',
    code: '[emoji_049]',
    label: '[抱拳]'
  }
]

export default emojiList
